<template>

    <section>

        <!-- ここから -->
        <form v-on:submit.prevent="newsPost">
        <div class="news_component">

            <div class="md_common-bl _padding-add _flex">
                <div class="inner">

                    <!-- LeftColumn -->
                    <div class="left-col">
                        <!-- PostTitle -->
                        <div class="post-title">
                            <!-- Title -->
                            <div class="item form_text _big">
                                <div class="input-row">
                                    <input type="text" maxlength="250" id="post-title">
                                </div>
                                <label for="post-title"><span>タイトル</span></label>
                            </div>
                        </div>
                        <!-- PostBody -->
                        <div class="post-body">
                            <div id="codex-editor" />
                        </div>
                    </div><!-- /LeftColumn -->

                    <!-- RightCol -->
                    <div class="right-col _news-setting">

                        <!-- SelectItem -->
                        <div class="item form_select">
                            <div class="text-row">ステータス</div>
                            <div class="input-row">
                                <select v-model="status" required>
                                    <option v-for="s in pulldown_status"
                                        v-bind:value="s.id "
                                        v-bind:key="s.id">
                                        {{ s.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- SelectItem -->
                        <div class="item form_select">
                            <div class="text-row">送信先</div>
                            <div class="input-row">
                                <select v-model="destination" required>
                                    <option v-for="d in pulldown_destination"
                                        v-bind:value="d.id "
                                        v-bind:key="d.id">
                                        {{ d.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <!--LinkBtn -->
                            <button class="btn_link md_icon-text _white">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCheck /></div>登録</span>
                                </div>
                            </button>

                        </div><!--/.btn-link-wrap-->

                    </div><!-- /.right-col -->

                </div>
            </div><!-- /.md_common-bl -->

        </div><!-- /.news_componentl -->
        </form>

        <!-- ここまで -->

    </section>

</template>


<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import EditorJS from '@editorjs/editorjs'

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            // "layout": AdminLayout,
            //Svg
            SvgIconCheck,
        },
        data() {
            return {
                status: '',
                destination: '',
                title: '',
                text: '',
                pulldown_status: [
                    { id: 0, name: '非公開' },
                    { id: 1, name: '公開' },
                    { id: 2, name: '下書き' },
                ],
                pulldown_destination: [
                    { id: 0, name: '全体' },
                    { id: 1, name: 'ショップ' },
                    { id: 2, name: 'ブランド' },
                ],
                news_id: 0, //0の場合は新規追加
                editor: {},
                page_title: 'admin - お知らせ新規作成＆編集画面',
            }
        },
        props: {
            news: Array,
        },
        mounted() {
            if (this.news) {
                this.news_id = this.news.id;
                this.destination = this.news.recipient;
                this.title = this.news.title;
                this.text = this.news.text;
                switch (this.news.recipient) {
                    case 0:
                        this.destination = '全体';
                        break;
                    case 1:
                        this.destination = 'ブランド';
                        break;
                    case 2:
                        this.destination = 'ショップ';
                        break;
                }
                switch (this.news.status) {
                    case 0:
                        this.status = '非公開';
                        break;
                    case 1:
                        this.status = '公開';
                        break;
                    case 2:
                        this.status = '下書き';
                        break;
                }
            }
            this.doEditor()
        },
        methods: {
            doEditor() {
                const savedData = this.text ? JSON.parse(this.text) : null
                this.editor = new EditorJS({
                    holder: 'codex-editor',
                    minHeight: 50,
                    placeholder: 'No content',
                    data: savedData,
                })
            },
            newsPost() {
                this.editor.save().then((outputData) => {
                    if (outputData.blocks.length) {
                        const form = reactive({
                            id: this.news_id,
                            status: this.status,
                            destination: this.destination,
                            title: this.title,
                            text: JSON.stringify(outputData),
                        })
                        Inertia.post('/admin/news/register', form, {
                            onStart: (visit) => {
                                this.page_title = '送信中・・・'
                            },
                            onError: (errors) => {
                                if (errors.text) {
                                    window.alert(errors.text);
                                }
                            },
                            onProgress: (progress) => {
                                // this.page_title = '送信中・・・'
                            },
                            onSuccess: (page) => {
                                this.status = '';
                                this.destination = '';
                                this.title = '';
                                this.text = '';
                                this.editor = {};
                                outputData = '';
                                alert('登録が完了しました')
                            },
                        })
                    } else {
                        window.alert('お知らせ詳細を入力してください');
                    }
                }).catch((error) => {
                    console.log('Saving failed: ', error)
                });
            },
        }
    }
</script>
